import './applied_date_view.js.coffee';# Added by Script 
class Monitoring.Views.SocialContents.Filters.AppliedPostDateView extends Monitoring.Views.SocialContents.Filters.AppliedDateView
  template: JST["backbone/templates/monitoring/filters/date/applied_post_date"]